module.exports = __webpack_public_path__ + "assets/img/td5.dbbdbc97.png";